<template>
  <div class="table">
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i> 关卡任务管理
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
      <div class="container">
        <div class="handle-box">
          <el-form ref="filter_from" inline :model="filter_from">
            <el-form-item>
              任务标识:
              <el-input v-model="filter_from.approval_code" value="" placeholder="任务标识" style="width: 120px"></el-input>
            </el-form-item>
            <el-form-item>
              任务名称:
              <el-input v-model="filter_from.task_name" value="" placeholder="任务名称" style="width: 120px"></el-input>
            </el-form-item>
            <el-form-item>
              任务类型:
              <el-select v-model="filter_from.task_type" value="" clearable placeholder="---------" style="width: 100px">
              <el-option
                v-for="item in options.task_type"
                :key="item.value"
                :label="item.text"
                :value="item.text">
              </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              封面图样式:
              <el-select v-model="filter_from.surface_type" value="" clearable placeholder="---------" style="width: 100px">
                <el-option
                      v-for="item in options.surface_type"
                      :key="item.value"
                      :label="item.text"
                      :value="item.text">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              紧急程度:
              <el-select v-model="filter_from.priority" value="" clearable placeholder="---------" style="width: 100px">
                <el-option
                  v-for="item in options.priority"
                  :key="item.value"
                  :label="item.text"
                  :value="item.text">
                  </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              区域数要求:
              <el-select v-model="filter_from.area_number" value="" clearable placeholder="---------" style="width: 140px">
                <el-option
                  v-for="item in options.area_number"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              CMS图片UID:
              <el-input v-model="filter_from.painting" clearable placeholder="CMS图片UID" style="width: 160px"></el-input>
            </el-form-item>
            <el-form-item>
              CMS创建时间:
              <el-date-picker
                v-model="filter_from.painting_create_timestamp_start"
                type="datetime"
                placeholder="开始时间"
                value-format="timestamp"
                style="width: 180px">
              </el-date-picker>
              -
              <el-date-picker
                v-model="filter_from.painting_create_timestamp_end"
                type="datetime"
                placeholder="结束时间"
                value-format="timestamp"
                style="width: 180px">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              所属生产计划:
              <!-- <el-input v-model="filter_from.plan" value="" clearable filterable placeholder="---------" style="width: 100px"></el-input> -->
              <el-select v-model="filter_from.plan" value="" clearable filterable placeholder="---------" style="width: 100px">
                <el-option
                  v-for="item in options.all_plan"
                  :key="item.value"
                  :label="item.text"
                  :value="item.text">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              图片分类:
              <el-tooltip
                :disabled="filter_from.img_cate.length === 0"
                placement="top"
                :open-delay="300">
                <div slot="content" class="img-cate-tooltip-content">{{ selectedImgCateText }}</div>
                <el-select
                  v-model="filter_from.img_cate"
                  class="img-cate-select"
                  :class="{ 'has-img-cate-overflow': imgCateOverflowCount > 0 }"
                  :style="{
                    width: '200px',
                    '--img-cate-overflow-text': imgCateOverflowCssText
                  }"
                  value=""
                  multiple
                  clearable
                  filterable
                  placeholder="---------">
                  <el-option
                    v-for="item in options.img_cate"
                    :key="item.value"
                    :label="item.text"
                    :value="item.text">
                  </el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
            <el-form-item>
              勾线难度:
              <el-select v-model="filter_from.draw_grade" value="" clearable placeholder="---------" style="width: 100px">
                <el-option
                  v-for="item in options.draw_grade"
                  :key="item.value"
                  :label="item.text"
                  :value="item.text">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              图片模式:
              <el-select v-model="filter_from.draw_theme" value="" clearable placeholder="---------" style="width: 100px">
                <el-option
                  v-for="item in options.draw_theme"
                  :key="item.value"
                  :label="item.text"
                  :value="item.text">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              色稿类型:
              <el-select v-model="filter_from.color" clearable placeholder="---------" style="width: 100px">
                <el-option
                  v-for="item in options.color"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              制作类型:
              <el-select v-model="filter_from.play_type" clearable placeholder="---------" style="width: 100px">
                <el-option
                  v-for="item in options.play_type"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              原创难度:
              <el-select v-model="filter_from.original_grade" value="" clearable placeholder="---------" style="width: 100px">
                <el-option
                  v-for="item in options.original_grade"
                  :key="item.value"
                  :label="item.text"
                  :value="item.text">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              任务状态:
              <el-select v-model="filter_from.task_status" value="" multiple collapse-tags clearable placeholder="---------" style="width: 180px">
                <el-option
                  v-for="item in options.task_status"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              所属组长:
              <el-select v-model="filter_from.leader_painter" value="" clearable filterable placeholder="---------" style="width: 100px">
                <el-option
                  v-for="item in options.leader_painter"
                  :key="item.username"
                  :label="item.username"
                  :value="item.username">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              分配画师:
              <el-select v-model="filter_from.painter" value="" clearable filterable placeholder="---------" style="width: 100px">
                <el-option
                  v-for="item in options.all_user"
                  :key="item.username"
                  :label="item.username"
                  :value="item.username">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              创建人:
              <el-input v-model="filter_from.created_by" value="" placeholder="输入创建人" style="width: 120px"></el-input>
            </el-form-item>
            <el-form-item>
              指定主管:
              <el-input v-model="filter_from.paint_manager" value="" placeholder="输入指定主管" style="width: 120px"></el-input>
            </el-form-item>
            <el-form-item v-show="this.user_info.role==3">
              过滤驳回任务:
              <el-select v-model="filter_from.reject" value="" clearable placeholder="---------" style="width: 100px">
              <el-option
                v-for="item in options.reject"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              题材:
              <el-select v-model="filter_from.subject_id" clearable filterable placeholder="---------" style="width: 120px">
                <el-option v-for="item in options.subject" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              题材类型:
              <el-select v-model="filter_from.subject_type" clearable filterable placeholder="---------" style="width: 100px">
                <el-option v-for="item in options.subject_type" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              美术团队:
              <el-select v-model="filter_from.art_team_id" clearable filterable placeholder="---------" style="width: 120px">
                <el-option v-for="item in options.art_team" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              项目组:
              <el-select v-model="filter_from.project_team_code" clearable filterable placeholder="---------" style="width: 120px">
                <el-option v-for="item in options.project_team" :key="item.code" :label="item.name" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" :loading="loading.search" @click="search">查 询</el-button>
            </el-form-item>
            <el-dialog title="创建任务-运营" :visible.sync="dialog.create" width="40%" :before-close="handle_close" :close-on-click-modal="false">
              <el-form  ref="form"  :model="form" label-width="110px" :rules="rules" class="create-form">
                  <el-form-item label="任务名称:" prop="task_name">
                    <el-input v-model="form.task_name" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="任务类型:" prop="task_type">
                    <el-radio-group v-model="form.task_type" clearable>
                      <el-radio
                        v-for="item in options.task_type"
                        :key="item.text"
                        :label="item.text"
                        :value="item.text"
                    ></el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="色稿类型:" v-if="form.task_type=='原创'" prop="color">
                    <el-radio-group v-model="form.color">
                      <el-radio
                        v-for="item in options.color"
                        :key="item.value"
                        :label="item.value"
                      >{{ item.label }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="制作类型:" v-if="form.task_type=='原创' && form.color=='normal'" prop="play_type">
                    <el-radio-group v-model="form.play_type">
                      <el-radio
                        v-for="item in options.play_type"
                        :key="item.value"
                        :label="item.value"
                      >{{ item.label }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="画师主管:" prop="paint_manager">
                    <el-select v-model="form.paint_manager" placeholder="请选择" clearable>
                      <el-option
                        v-for="item in options.paint_manager"
                        :key="item.username"
                        :label="item.username"
                        :value="item.username"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="封面图样式:" prop="surface_type">
                    <el-radio-group v-model="form.surface_type" size="medium">
                      <el-radio
                        v-for="item in options.surface_type"
                        :key="item.text"
                        :label="item.text"
                        :value="item.text"
                    ></el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="紧急程度:" prop="priority">
                    <el-radio-group v-model="form.priority" size="medium">
                      <el-radio
                        v-for="item in options.priority"
                        :key="item.text"
                        :label="item.text"
                        :value="item.text"
                    ></el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="要求完成日期:" prop="plan_date" v-show="form.priority == '紧急'">
                    <div class="block">
                    <el-date-picker
                      v-model="form.plan_date"
                      type="date"
                      placeholder="选择日期"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd">
                    </el-date-picker>
                  </div>
                  </el-form-item>
                  <el-form-item class="area-number-form-item" label="区域数要求:" prop="area_number">
                    <el-select v-model="form.area_number" placeholder="请选择" clearable style="width: 100%">
                      <el-option
                        v-for="item in options.area_number"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="所属生产计划:" prop="plan">
                    <el-select v-model="form.plan" placeholder="请选择" clearable>
                      <el-option
                        v-for="item in options.plan"
                        :key="item.text"
                        :label="item.text"
                        :value="item.text"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="图片分类:" prop="img_cate">
                    <el-select v-model="form.img_cate" placeholder="请选择" clearable filterable>
                      <el-option
                        v-for="item in options.img_cate"
                        :key="item.text"
                        :label="item.text"
                        :value="item.text"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="勾线难度:" v-show="form.task_type=='勾线'" prop="draw_grade">
                    <el-select v-model="form.draw_grade" placeholder="请选择" clearable>
                      <el-option
                        v-for="item in options.draw_grade"
                        :key="item.text"
                        :label="item.text"
                        :value="item.text"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="勾线图片:" v-show="form.task_type=='勾线'">
                    <el-upload
                      class="upload-demo"
                      ref="upload"
                      action=""
                      :data="{ uploadType: 'ai' }"
                      :http-request="handle_upload_request"
                      :on-remove="handle_remove"
                      :on-success="handle_success"
                      :file-list="file_list"
                      :multiple="false"
                      list-type="picture"
                      drag>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    </el-upload>
                    <div v-show="loading.upload_ai" class="uploading-tip">上传中...</div>
                  </el-form-item>
                  <el-form-item label="参考图片:" v-show="form.task_type=='原创'">
                    <el-upload
                      class="upload-demo"
                      ref="upload"
                      action=""
                      :data="{ uploadType: 'org' }"
                      :http-request="handle_upload_request"
                      :on-remove="handle_remove_org"
                      :on-success="handle_success_org"
                      :file-list="file_list_org"
                      list-type="picture"
                      drag
                      :multiple="true">
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    </el-upload>
                    <div v-show="loading.upload_org" class="uploading-tip">上传中...</div>
                  </el-form-item>
                  <el-form-item label="原创要求:"  v-show="form.task_type=='原创'" prop="original_require">
                    <el-autocomplete
                    v-model="form.original_require"
                    :fetch-suggestions="querySearch"
                    @select="handleSelect"
                    type="textarea"
                    :style="{ width: '500px'}"
                    :autosize="{ minRows: 2, maxRows: 5 }"
                    clearable
                    >
                    <template slot-scope="{ item }">{{ item }}</template>
                    </el-autocomplete>
                  </el-form-item>
              </el-form>
              <div>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="handle_close">取 消</el-button>
                  <el-button type="primary" @click="create" :loading="loading.create">确 定</el-button>
                </span>
              </div>
            </el-dialog>
            <el-dialog title="批量创建任务-运营" :visible.sync="dialog.batch_create" width="40%" :before-close="handle_close" :close-on-click-modal="false">
              <el-form  ref="form"  :model="form" label-width="110px" :rules="rules" class="create-form">
                  <el-form-item label="任务名称:" prop="task_name">
                    <el-input v-model="form.task_name"></el-input>
                  </el-form-item>
                  <el-form-item label="任务类型:" prop="task_type">
                    <el-radio-group v-model="form.task_type">
                      <el-radio
                        v-for="item in options.task_type"
                        :key="item.text"
                        :label="item.text"
                        :value="item.text"
                    ></el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="色稿类型:" v-if="form.task_type=='原创'" prop="color">
                    <el-radio-group v-model="form.color">
                      <el-radio
                        v-for="item in options.color"
                        :key="item.value"
                        :label="item.value"
                      >{{ item.label }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="制作类型:" v-if="form.task_type=='原创' && form.color=='normal'" prop="play_type">
                    <el-radio-group v-model="form.play_type">
                      <el-radio
                        v-for="item in options.play_type"
                        :key="item.value"
                        :label="item.value"
                      >{{ item.label }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="画师主管:" prop="paint_manager">
                    <el-select v-model="form.paint_manager" placeholder="请选择" clearable>
                      <el-option
                        v-for="item in options.paint_manager"
                        :key="item.username"
                        :label="item.username"
                        :value="item.username"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="封面图样式:" prop="surface_type">
                    <el-radio-group v-model="form.surface_type" size="medium">
                      <el-radio
                        v-for="item in options.surface_type"
                        :key="item.text"
                        :label="item.text"
                        :value="item.text"
                    ></el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="紧急程度:" prop="priority">
                    <el-radio-group v-model="form.priority" size="medium">
                      <el-radio
                        v-for="item in options.priority"
                        :key="item.text"
                        :label="item.text"
                        :value="item.text"
                    ></el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="要求完成日期:" prop="plan_date"  v-show="form.priority == '紧急'">
                    <div class="block">
                    <el-date-picker
                      v-model="form.plan_date"
                      type="date"
                      placeholder="选择日期"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd">
                    </el-date-picker>
                  </div>
                  </el-form-item>
                  <el-form-item class="area-number-form-item" label="区域数要求:" prop="area_number">
                    <el-select v-model="form.area_number" placeholder="请选择" clearable style="width: 100%">
                      <el-option
                        v-for="item in options.area_number"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="所属生产计划:" prop="plan">
                    <el-select v-model="form.plan" placeholder="请选择" clearable>
                      <el-option
                        v-for="item in options.plan"
                        :key="item.text"
                        :label="item.text"
                        :value="item.text"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="图片分类:" prop="img_cate" >
                    <el-select v-model="form.img_cate" placeholder="请选择" clearable filterable>
                      <el-option
                        v-for="item in options.img_cate"
                        :key="item.text"
                        :label="item.text"
                        :value="item.text"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="原创要求:"  v-show="form.task_type=='原创'" prop="original_require">
                    <el-autocomplete
                    v-model="form.original_require"
                    :fetch-suggestions="querySearch"
                    @select="handleSelect"
                    type="textarea"
                    :style="{ width: '500px'}"
                    :autosize="{ minRows: 2, maxRows: 5 }"
                    clearable
                    >
                    <template slot-scope="{ item }">{{ item }}</template>
                    </el-autocomplete>
                  </el-form-item>
                  <el-form-item label="勾线难度:" v-show="form.task_type=='勾线'" prop="draw_grade">
                    <el-select v-model="form.draw_grade" placeholder="请选择" clearable>
                      <el-option
                        v-for="item in options.draw_grade"
                        :key="item.text"
                        :label="item.text"
                        :value="item.text"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="勾线图片:" v-show="form.task_type=='勾线'">
                    <el-upload
                      class="upload-demo"
                      ref="upload"
                      action=""
                      :http-request="handle_upload_request"
                      :file-list="batch_file_list"
                      :on-change="handle_upload_change_batch"
                      :on-progress="handle_upload_progress_batch"
                      :on-success="handle_success_batch"
                      :limit="30"
                      :on-exceed="handle_exceed_batch"
                      drag
                      multiple>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    </el-upload>
                    <div v-show="loading.batch_upload" class="uploading-tip">上传中...</div>
                  </el-form-item>
                  <el-form-item label="创建方式:" v-show="form.task_type=='原创'">
                    <el-radio-group v-model="form.original_create_type">
                      <el-radio
                        v-for="item in options.original_create_type"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    ></el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="任务数量:"  v-show="form.task_type=='原创' & form.original_create_type == '按任务数量'">
                    <el-input v-model="form.task_number"></el-input>
                  </el-form-item>
                  <el-form-item label="参考图片:" v-show="form.task_type=='原创' & form.original_create_type == '按参考图片'">
                    <el-upload
                      class="upload-demo"
                      ref="upload"
                      action=""
                      :http-request="handle_upload_request"
                      :file-list="batch_file_list"
                      :on-change="handle_upload_change_batch"
                      :on-progress="handle_upload_progress_batch"
                      :on-success="handle_success_batch"
                      :limit="30"
                      :on-exceed="handle_exceed_batch"
                      drag
                      multiple>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    </el-upload>
                    <div v-show="loading.batch_upload" class="uploading-tip">上传中...</div>
                  </el-form-item>

              </el-form>
              <div>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="handle_close">取 消</el-button>
                  <el-button type="primary" @click="batch_create" :loading="loading.batch_create">确 定</el-button>
                </span>
              </div>
            </el-dialog>
          </el-form>
        </div>
      <div>
        <span style="float: left; margin: 10px; margin-right: 50px">已选: {{all_select_count}}张</span>
        <el-button type="primary"  @click="dialog.create=true" v-show="this.user_info.role==3">创建任务</el-button>
        <el-button type="primary"  @click="dialog.batch_create=true" v-show="this.user_info.role==3">批量创建</el-button>
        <el-dropdown class="updata" @command="pre_batch_update_fields" :disabled="this.all_select_count==0 || judge_disabled('batch_update_fields')">
          <el-button type="primary" :disabled="this.all_select_count==0 || judge_disabled('batch_update_fields')">
            批量编辑<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="paint_manager">画师主管</el-dropdown-item>
            <el-dropdown-item command="plan">生产计划</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button type="success"  @click="dialog.batch_verify=true" v-show="this.user_info.role==3" :disabled="this.all_select_count==0 || judge_disabled('batch_verify')" >批量确认</el-button>
        <el-button type="danger"  @click="dialog.batch_delete=true" v-show="this.user_info.role==3" :disabled="this.all_select_count==0  || judge_disabled('batch_delete')">批量删除</el-button>
        <el-button type="success"  @click="pre_batch_pass" v-show="this.user_info.role==6" :disabled="this.all_select_count==0 || judge_disabled('batch_pass')">批量审批</el-button>
        <el-button type="success"  @click="pre_batch_appoint" v-show="this.user_info.role==2" :disabled="this.all_select_count==0 || judge_disabled('batch_appoint')">批量分配</el-button>
        <el-button type="success"  @click="pre_batch_review" v-show="this.user_info.role==2" :disabled="this.all_select_count==0 || judge_disabled('batch_review')">批量审批</el-button>
        <el-button type="danger"  @click="dialog.batch_reject=true" v-show="[2,3,6].includes(this.user_info.role)" :disabled="this.all_select_count==0 || judge_disabled('batch_reject')">批量驳回</el-button>
        <el-button type="info" icon="el-icon-s-comment" @click="sync_task_status"  style="margin-left: 10px;" round>{{ task_msg }}</el-button>
        <el-button type="primary" @click="curr_reject_count" :loading="this.loading.reject_count" v-show="this.user_info.role==3 & this.reject_count !=''">当前 {{ this.reject_count }} 个驳回任务待处理</el-button>
      </div>


      <el-table
          :data="tableData" 
          border
          class="table"
          row-key="id"
          ref="multipleTable"
          @select="select"
          @select-all="select_all"
        >
        <el-table-column type="selection" width="40"  :reserve-selection="true"></el-table-column>
        <el-table-column prop="id" label="ID" align="center" ></el-table-column>
        <el-table-column prop="approval_code" label="任务标识" align="center" ></el-table-column>
        <el-table-column prop="task_name" label="任务名称" align="center" ></el-table-column>
        <el-table-column prop="task_type" label="任务类型" align="center" ></el-table-column>
        <el-table-column prop="priority" label="紧急程度" align="center" ></el-table-column>
        <el-table-column prop="area_number" label="区域数要求" align="center" ></el-table-column>
        <el-table-column prop="plan" label="所属生产计划" align="center" ></el-table-column>
        <el-table-column prop="painting" label="CMS图片UID" align="center" ></el-table-column>
        <el-table-column prop="painting_create_timestamp" label="CMS创建时间" align="center" :formatter="formatPaintingCreateTimestamp" ></el-table-column>
        <el-table-column prop="img_cate" label="图片分类" align="center" ></el-table-column>
        <el-table-column prop="created_by" label="创建人" align="center" ></el-table-column>
        <el-table-column prop="paint_manager" label="指定主管" align="center" ></el-table-column>
        <el-table-column label="所属组长" align="center">
          <template slot-scope="scope">
            {{ scope.row.paint_leader ||  scope.row.virtual_paint_leader}}
          </template>
        </el-table-column>
        <el-table-column prop="painter" label="分配画师" align="center" ></el-table-column>
        <el-table-column prop="original_require" label="原创要求" align="center" ></el-table-column>
        <el-table-column prop="ai_image" label="勾线/原创图片" width="200dp" align="center" >
          <template scope="scope">
            <img v-if="scope.row.task_type === '勾线'" :src="scope.row.ai_image" v-viewer width="80" height="80" />
            <template v-else-if="scope.row.ref_image">
              <img v-for="(image, index) in scope.row.ref_image.split(';')" :key="index" :src="image" v-viewer width="80" height="80" style="margin-right: 5px;" />
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="ai_image" label="勾线/原创难度" align="center" >
          <template scope="scope">
            {{ scope.row.draw_grade ||  scope.row.original_grade}}
          </template>
        </el-table-column>
        <el-table-column prop="draw_theme" label="图片模式" align="center" ></el-table-column>
        <el-table-column prop="color" label="色稿类型" align="center" :formatter="formatColor" ></el-table-column>
        <el-table-column prop="play_type" label="制作类型" align="center" :formatter="formatPlayType" ></el-table-column>
        <el-table-column prop="withdraw_reason" label="运营驳回理由" align="center" ></el-table-column>
        <el-table-column prop="reject_reason" label="驳回理由" align="center" ></el-table-column>
        <el-table-column prop="production_dimensions.subject_name" label="题材" align="center" :formatter="formatProductionDimension" />
        <el-table-column prop="production_dimensions.subject_type" label="题材类型" align="center" :formatter="formatProductionDimension" />
        <el-table-column prop="production_dimensions.art_team_name" label="美术团队" align="center" :formatter="formatProductionDimension" />
        <el-table-column prop="production_dimensions.project_team_name" label="项目组" align="center" :formatter="formatProductionDimension" />
        <el-table-column label="操作"  align="center" width="220dp" fixed="right">
          <template slot-scope="scope">
            <div style="display: flex; ">              
              <el-button type="primary" v-if="scope.row.task_status==1" @click="verify_task(scope.row.id)" :disabled="get_disabled(scope.row.created_by)">自审</el-button>
              <el-button type="primary" v-if="scope.row.task_status==1" @click="pre_update(scope.row)" :disabled="get_disabled(scope.row.created_by)">编辑</el-button>
              <el-button type="danger"  v-if="scope.row.task_status==1" @click="pre_delete(scope.row)" :disabled="get_disabled(scope.row.created_by)">删除</el-button>
              <el-button type="primary" v-if="scope.row.task_status==2" @click="check_approve(scope.row.id, 3) " :disabled="user_info.role != 3">运营互审</el-button>
              <el-button type="primary" v-if="scope.row.task_status==3" @click="pre_review(scope.row)" :disabled="get_disabled(scope.row.paint_manager)">主管审阅</el-button>
              <el-button type="primary" v-if="scope.row.task_status==4 && scope.row.paint_leader" @click="pre_leader_appoint(scope.row)" :disabled="get_disabled(scope.row.paint_leader)">组长分配</el-button>
              <el-button type="primary" v-if="scope.row.task_status==4 && ! scope.row.paint_leader" @click="pre_leader_review(scope.row)" :disabled="get_disabled(scope.row.virtual_paint_leader)">组长审批</el-button>
              <el-button type="primary" v-if="scope.row.task_status==5" @click="check_approve(scope.row.id, 6)" :disabled="true">画师认领</el-button>
              <el-button type="primary" v-if="scope.row.task_status==6" @click="check_approve(scope.row.id, 7)" :disabled="true" >主管审核</el-button>
              <el-button type="primary" v-if="scope.row.task_status==6" @click="check_approve(scope.row.id, 7)" :disabled="get_disabled(scope.row.paint_manager)" >主管审核</el-button>
              <el-button type="primary" v-if="scope.row.task_status==7" @click="check_approve(scope.row.id, 8)" :disabled="true">运营审批</el-button>
              <el-button type="warning" v-if="[2,3,4,5].includes(scope.row.task_status)" @click="pre_reject(scope.row)" :disabled="get_reject_disabled(scope.row)">驳回</el-button>
              <el-button type="danger" v-if="[2,3,4,5].includes(scope.row.task_status)" @click="pre_recall(scope.row)" :disabled="get_recall_disabled(scope.row)">撤回</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
          <el-pagination
              background
              @size-change="search"
              @current-change="search"
              :current-page.sync="cur_page"
              :page-size.sync="size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total_count"
              :page-size="size"
              :page-sizes="[10, 20, 40, 80, 300]"
              align="center"
          ></el-pagination>
      </div>
      <el-dialog title="组长分配任务" :visible.sync="dialog.leader_appoint" width="40%" :before-close="handle_close" :close-on-click-modal="false">
        <el-form  ref="review_data_form"  :model="review_data_form" label-width="110px" >
          <el-form-item label="分配画师:">
                  <el-select v-model="review_data_form.painter" placeholder="请选择" clearable filterable>
                    <el-option
                      v-for="item in painter"
                      :key="item.username"
                      :label="item.username"
                      :value="item.username"
                    ></el-option>
                  </el-select>
          </el-form-item>
          <el-form-item label="图片模式:"  v-show="review_data_form.task_type=='原创'">
            <el-radio-group v-model="review_data_form.draw_theme" size="medium">
              <el-radio
                v-for="item in options.draw_theme"
                :key="item.text"
                :label="item.text"
                :value="item.text"
            ></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="原创难度:"  v-show="review_data_form.task_type=='原创'">
            <el-radio-group v-model="review_data_form.original_grade" size="medium">
              <el-radio
                v-for="item in options.original_grade"
                :key="item.text"
                :label="item.text"
                :value="item.text"
              ></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="勾线难度:"  v-show="review_data_form.task_type=='勾线'">
            <el-radio-group v-model="review_data_form.draw_grade" size="medium">
              <el-radio
                v-for="item in options.draw_grade"
                :key="item.text"
                :label="item.text"
                :value="item.text"
              ></el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="handle_close">取 消</el-button>
            <el-button type="warning" @click="sub_leader_review" :loading="loading.sub_leader_appoint">保存为草稿</el-button>
            <el-button type="primary" @click="leader_review" :loading="loading.leader_appoint">确 定</el-button>
          </span>
        </div>
      </el-dialog>
      <el-dialog title="组长审批任务" :visible.sync="dialog.leader_review" width="40%" :before-close="handle_close" :close-on-click-modal="false">
        <el-form  ref="review_data_form"  :model="review_data_form" label-width="110px" >
          <el-form-item label="图片模式:"  v-show="review_data_form.task_type=='原创'">
            <el-radio-group v-model="review_data_form.draw_theme" size="medium">
              <el-radio
                v-for="item in options.draw_theme"
                :key="item.text"
                :label="item.text"
                :value="item.text"
            ></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="原创难度:"  v-show="review_data_form.task_type=='原创'">
            <el-radio-group v-model="review_data_form.original_grade" size="medium">
              <el-radio
                v-for="item in options.original_grade"
                :key="item.text"
                :label="item.text"
                :value="item.text"
              ></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="勾线难度:"  v-show="review_data_form.task_type=='勾线'">
            <el-radio-group v-model="review_data_form.draw_grade" size="medium">
              <el-radio
                v-for="item in options.draw_grade"
                :key="item.text"
                :label="item.text"
                :value="item.text"
              ></el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="handle_close">取 消</el-button>
            <el-button type="warning" @click="sub_leader_review" :loading="loading.sub_leader_review">保存为草稿</el-button>
            <el-button type="primary" @click="leader_review" :loading="loading.leader_review">确 定</el-button>
          </span>
        </div>
      </el-dialog>
      <el-dialog title="批量分配" :visible.sync="dialog.batch_appoint" width="40%" :before-close="handle_close" :close-on-click-modal="false">
        <el-form  ref="review_data_form"  :model="review_data_form" label-width="110px" >
          <el-form-item label="分配画师:">
                  <el-select v-model="review_data_form.painter" placeholder="请选择" clearable filterable>
                    <el-option
                      v-for="item in painter"
                      :key="item.username"
                      :label="item.username"
                      :value="item.username"
                    ></el-option>
                  </el-select>
          </el-form-item>
          <el-form-item label="图片模式:"  v-show="review_data_form.task_type=='原创'">
            <el-radio-group v-model="review_data_form.draw_theme" size="medium">
              <el-radio
                v-for="item in options.draw_theme"
                :key="item.text"
                :label="item.text"
                :value="item.text"
            ></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="原创难度:"  v-show="review_data_form.task_type=='原创'">
            <el-radio-group v-model="review_data_form.original_grade" size="medium">
              <el-radio
                v-for="item in options.original_grade"
                :key="item.text"
                :label="item.text"
                :value="item.text"
              ></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="勾线难度:"  v-show="review_data_form.task_type=='勾线'">
            <el-radio-group v-model="review_data_form.draw_grade" size="medium">
              <el-radio
                v-for="item in options.draw_grade"
                :key="item.text"
                :label="item.text"
                :value="item.text"
              ></el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="handle_close">取 消</el-button>
            <el-button type="warning" @click="sub_batch_appoint" :loading="loading.sub_batch_appoint">保存为草稿</el-button>
            <el-button type="primary" @click="batch_appoint" :loading="loading.batch_appoint">确 定</el-button>
          </span>
        </div>
      </el-dialog>
      <el-dialog title="批量审批" :visible.sync="dialog.batch_review" width="40%" :before-close="handle_close" :close-on-click-modal="false">
        <el-form  ref="review_data_form"  :model="review_data_form" label-width="110px" >
          <el-form-item label="图片模式:"  v-show="review_data_form.task_type=='原创'">
            <el-radio-group v-model="review_data_form.draw_theme" size="medium">
              <el-radio
                v-for="item in options.draw_theme"
                :key="item.text"
                :label="item.text"
                :value="item.text"
            ></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="原创难度:"  v-show="review_data_form.task_type=='原创'">
            <el-radio-group v-model="review_data_form.original_grade" size="medium">
              <el-radio
                v-for="item in options.original_grade"
                :key="item.text"
                :label="item.text"
                :value="item.text"
              ></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="勾线难度:"  v-show="review_data_form.task_type=='勾线'">
            <el-radio-group v-model="review_data_form.draw_grade" size="medium">
              <el-radio
                v-for="item in options.draw_grade"
                :key="item.text"
                :label="item.text"
                :value="item.text"
              ></el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="handle_close">取 消</el-button>
            <el-button type="warning" @click="sub_batch_review" :loading="loading.sub_batch_review">保存为草稿</el-button>
            <el-button type="primary" @click="batch_review" :loading="loading.batch_review">确 定</el-button>
          </span>
        </div>
      </el-dialog>
      <el-dialog title="主管审阅任务" :visible.sync="dialog.review" width="40%" :before-close="handle_close" :close-on-click-modal="false">
        <el-form  ref="review_data_form"  :model="review_data_form" label-width="110px" >
          <el-form-item label="组长分配:" >
            <el-radio-group v-model="review_data_form.is_appoint" size="medium">
              <el-radio
                v-for="item in options.boole"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            ></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="分配画师:" v-show="review_data_form.is_appoint == '否'">
              <el-select v-model="review_data_form.painter" placeholder="请选择" clearable filterable >
                <el-option
                  v-for="item in painter"
                  :key="item.username"
                  :label="item.username"
                  :value="item.username"
                ></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="指定组长:" v-show="review_data_form.is_appoint == '是'">
              <el-select v-model="review_data_form.paint_leader" placeholder="请选择" clearable filterable >
                <el-option
                  v-for="item in leader_painter"
                  :key="item.username"
                  :label="item.username"
                  :value="item.username"
                ></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="图片模式:"  v-show="review_data_form.task_type=='原创'">
            <el-radio-group v-model="review_data_form.draw_theme" size="medium">
              <el-radio
                v-for="item in options.draw_theme"
                :key="item.text"
                :label="item.text"
                :value="item.text"
            ></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="原创难度:"  v-show="review_data_form.task_type=='原创'">
            <el-radio-group v-model="review_data_form.original_grade" size="medium">
              <el-radio
                v-for="item in options.original_grade"
                :key="item.text"
                :label="item.text"
                :value="item.text"
              ></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="色稿类型:" v-show="review_data_form.task_type=='原创'">
            <el-radio-group v-model="review_original_type_form.color">
              <el-radio
                v-for="item in options.color"
                :key="item.value"
                :label="item.value"
              >{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="制作类型:" v-show="review_data_form.task_type=='原创' && review_original_type_form.color=='normal'">
            <el-radio-group v-model="review_original_type_form.play_type">
              <el-radio
                v-for="item in options.play_type"
                :key="item.value"
                :label="item.value"
              >{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="勾线难度:"  v-show="review_data_form.task_type=='勾线'">
            <el-radio-group v-model="review_data_form.draw_grade" size="medium">
              <el-radio
                v-for="item in options.draw_grade"
                :key="item.text"
                :label="item.text"
                :value="item.text"
              ></el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="handle_close">取 消</el-button>
            <el-button type="warning" @click="sub_review" :loading="loading.sub_review">保存为草稿</el-button>
            <el-button type="primary" @click="review" :loading="loading.review">确 定</el-button>
          </span>
        </div>
      </el-dialog>
      <el-dialog title="驳回" :visible.sync="dialog.reject" width="25%" :before-close="handle_close" :close-on-click-modal="false">
        <el-form  ref="reject_form"  :model="reject_form" label-width="110px" >
          <el-form-item label="驳回理由:">
            <el-input v-model="reject_form.reject_msg"></el-input>
          </el-form-item>
        </el-form>
          <div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="handle_close">取 消</el-button>
              <el-button type="primary" @click="reject" :loading="loading.reject">确 定</el-button>
            </span>
          </div>
      </el-dialog>
      <el-dialog title="撤回" :visible.sync="dialog.recall" width="25%" :before-close="handle_close" :close-on-click-modal="false">
          <div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="handle_close">取 消</el-button>
              <el-button type="primary" @click="recall" :loading="loading.recall">确 定</el-button>
            </span>
          </div>
      </el-dialog>
      <el-dialog title="删除" :visible.sync="dialog.delete" width="25%" :before-close="handle_close" :close-on-click-modal="false">
          <span>确认删除吗? </span>
          <div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="handle_close">取 消</el-button>
              <el-button type="primary" @click="reject" :loading="loading.delete">确 定</el-button>
            </span>
          </div>
      </el-dialog>
      <el-dialog title="编辑" :visible.sync="dialog.update" width="40%" :before-close="handle_close" :close-on-click-modal="false">
        <el-form  ref="update_form"  :model="update_form" label-width="110px" :rules="rules">
          <el-form-item label="任务名称:" prop="task_name">
            <el-input v-model="update_form.task_name"></el-input>
          </el-form-item>
          <el-form-item label="任务类型:" prop="task_type">
            <el-radio-group v-model="update_form.task_type">
              <el-radio
                v-for="item in options.task_type"
                :key="item.text"
                :label="item.text"
                :value="item.text"
            ></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="色稿类型:" v-if="update_form.task_type=='原创'" prop="color">
            <el-radio-group v-model="update_form.color">
              <el-radio
                v-for="item in options.color"
                :key="item.value"
                :label="item.value"
              >{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="制作类型:" v-if="update_form.task_type=='原创' && update_form.color=='normal'" prop="play_type">
            <el-radio-group v-model="update_form.play_type">
              <el-radio
                v-for="item in options.play_type"
                :key="item.value"
                :label="item.value"
              >{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="画师主管:" prop="paint_manager">
            <el-select v-model="update_form.paint_manager" placeholder="请选择">
              <el-option
                v-for="item in options.paint_manager"
                :key="item.username"
                :label="item.username"
                :value="item.username"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="封面图样式:" prop="surface_type">
            <el-radio-group v-model="update_form.surface_type" size="medium">
              <el-radio
                v-for="item in options.surface_type"
                :key="item.text"
                :label="item.text"
                :value="item.text"
            ></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="紧急程度:" prop="priority">
            <el-radio-group v-model="update_form.priority" size="medium">
              <el-radio
                v-for="item in options.priority"
                :key="item.text"
                :label="item.text"
                :value="item.text"
            ></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="区域数要求:" prop="area_number">
            <el-select v-model="update_form.area_number" placeholder="请选择" clearable style="width: 100%">
              <el-option
                v-for="item in options.area_number"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属生产计划:" prop="plan">
            <el-select v-model="update_form.plan" placeholder="请选择">
              <el-option
                v-for="item in options.plan"
                :key="item.text"
                :label="item.text"
                :value="item.text"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="要求完成日期:" prop="plan_date"  v-show="update_form.priority == '紧急'">
            <div class="block">
            <el-date-picker
              v-model="update_form.plan_date"
              type="date"
              placeholder="选择日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd">
            </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="图片分类:" prop="img_cate">
            <el-select v-model="update_form.img_cate" placeholder="请选择">
              <el-option
                v-for="item in options.img_cate"
                :key="item.text"
                :label="item.text"
                :value="item.text"
              ></el-option>
            </el-select>
          </el-form-item>
                  <el-form-item label="勾线难度:" v-show="update_form.task_type=='勾线'" prop="draw_grade">
            <el-select v-model="update_form.draw_grade" placeholder="请选择">
              <el-option
                v-for="item in options.draw_grade"
                :key="item.text"
                :label="item.text"
                :value="item.text"
              ></el-option>
            </el-select>
          </el-form-item>
                  <el-form-item label="勾线图片:" v-show="update_form.task_type=='勾线'">
            <el-upload
              class="upload-demo"
              ref="upload"
              action=""
              :data="{ uploadType: 'ai' }"
              :http-request="handle_upload_request"
              :on-remove="handle_remove"
              :on-success="handle_success"
              :file-list="file_list"
              :multiple="false"
              :limit="1"
              :on-exceed="handle_exceed"
              list-type="picture"
              drag>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
            <div v-show="loading.upload_ai" class="uploading-tip">上传中...</div>
          </el-form-item>
          <el-form-item label="原创要求:"  v-show="update_form.task_type=='原创'">
            <el-autocomplete
              v-model="update_form.original_require"
              :fetch-suggestions="querySearch_update"
              @select="handleSelect_update"
              type="textarea"
              :style="{ width: '500px'}"
              :autosize="{ minRows: 2, maxRows: 5 }"
              clearable
              >
              <template slot-scope="{ item }">{{ item }}</template>
              </el-autocomplete>
          </el-form-item>
          <el-form-item label="参考图片:" v-show="update_form.task_type=='原创'">
            <el-upload
              class="upload-demo"
              ref="upload"
              action=""
              :data="{ uploadType: 'org' }"
              :http-request="handle_upload_request"
              :file-list="file_list_org"
              :on-remove="handle_remove_org"
              :on-success="handle_success_org"
              :multiple="update_form.task_type=='原创'"
              :limit="5"
              :on-exceed="handle_exceed_org"
              list-type="picture-card"
              drag>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
            <div v-show="loading.upload_org" class="uploading-tip">上传中...</div>
          </el-form-item>
        </el-form>
      <div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handle_close">取 消</el-button>
          <el-button type="primary" @click="update" :loading="loading.update">确 定</el-button>
        </span>
      </div>
      </el-dialog>
      <el-dialog title="批量确认" :visible.sync="dialog.batch_verify" width="25%" :before-close="handle_close" :close-on-click-modal="false">
        <span>请检查好任务, 没问题点击确定</span>
        <div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handle_close">取 消</el-button>
          <el-button type="primary" @click="batch_verify" :loading="loading.batch_verify">确 定</el-button>
        </span>
      </div>
      </el-dialog>
      <el-dialog title="批量删除" :visible.sync="dialog.batch_delete" width="25%" :before-close="handle_close" :close-on-click-modal="false">
        <span>您确认删除吗?</span>
        <div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handle_close">取 消</el-button>
          <el-button type="danger" @click="batch_delete" :loading="loading.batch_delete">删 除</el-button>
        </span>
      </div>
      </el-dialog>
      <el-dialog :title="batch_update_field_type === 'paint_manager' ? '批量编辑画师主管' : '批量编辑生产计划'" :visible.sync="dialog.batch_update_fields" width="35%" :before-close="handle_close" :close-on-click-modal="false">
        <div>
          <el-form ref="batch_update_fields_form" :model="batch_update_fields_form" label-width="110px" :rules="batch_update_fields_rules">
            <el-form-item v-if="batch_update_field_type === 'paint_manager'" label="画师主管:" prop="paint_manager">
              <el-select v-model="batch_update_fields_form.paint_manager" placeholder="请选择" clearable filterable>
                <el-option
                  v-for="item in options.paint_manager"
                  :key="item.username"
                  :label="item.username"
                  :value="item.username"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="batch_update_field_type === 'plan'" label="所属生产计划:" prop="plan">
              <el-select v-model="batch_update_fields_form.plan" placeholder="请选择" clearable filterable>
                <el-option
                  v-for="item in options.plan"
                  :key="item.text"
                  :label="item.text"
                  :value="item.text"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="handle_close">取 消</el-button>
            <el-button type="primary" @click="batch_update_fields" :loading="loading.batch_update_fields">确 定</el-button>
          </span>
        </div>
      </el-dialog>
      <el-dialog title="批量审批" :visible.sync="dialog.batch_pass" width="40%" :before-close="handle_close" :close-on-click-modal="false">
        <div>
          <el-form  ref="review_data_form"  :model="review_data_form" label-width="110px" >
            <el-form-item label="组长分配:" >
              <el-radio-group v-model="review_data_form.is_appoint" size="medium">
                <el-radio
                  v-for="item in options.boole"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              ></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="分配画师:" v-show="review_data_form.is_appoint == '否'">
                    <el-select v-model="review_data_form.painter" placeholder="请选择" clearable filterable>
                      <el-option
                        v-for="item in painter"
                        :key="item.username"
                        :label="item.username"
                        :value="item.username"
                      ></el-option>
                    </el-select>
            </el-form-item>
            <el-form-item label="指定组长:" v-show="review_data_form.is_appoint == '是'">
                    <el-select v-model="review_data_form.paint_leader" placeholder="请选择" clearable filterable>
                      <el-option
                        v-for="item in leader_painter"
                        :key="item.username"
                        :label="item.username"
                        :value="item.username"
                      ></el-option>
                    </el-select>
            </el-form-item>
            <el-form-item label="图片模式:"  v-show="review_data_form.task_type=='原创'">
              <el-radio-group v-model="review_data_form.draw_theme" size="medium">
                <el-radio
                  v-for="item in options.draw_theme"
                  :key="item.text"
                  :label="item.text"
                  :value="item.text"
              ></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="原创难度:"  v-show="review_data_form.task_type=='原创'">
              <el-radio-group v-model="review_data_form.original_grade" size="medium">
                <el-radio
                  v-for="item in options.original_grade"
                  :key="item.text"
                  :label="item.text"
                  :value="item.text"
              ></el-radio>
            </el-radio-group>
             </el-form-item>
            <el-form-item label="勾线难度:"  v-show="review_data_form.task_type=='勾线'">
              <el-radio-group v-model="review_data_form.draw_grade" size="medium">
                <el-radio
                  v-for="item in options.draw_grade"
                  :key="item.text"
                  :label="item.text"
                  :value="item.text"
              ></el-radio>
            </el-radio-group>
             </el-form-item>
          </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handle_close">取 消</el-button>
          <el-button type="warning" @click="sub_batch_pass" :loading="loading.sub_batch_pass">保存为草稿</el-button>
          <el-button type="primary" @click="batch_pass" :loading="loading.batch_pass">确 认</el-button>
        </span>
      </div>
      </el-dialog>
      <el-dialog title="批量驳回" :visible.sync="dialog.batch_reject" width="40%" :before-close="handle_close" :close-on-click-modal="false">
        <div>
          <el-form  ref="reject_form"  :model="reject_form" label-width="110px" >
          <el-form-item label="驳回理由:">
            <el-input  type="textarea" v-model="reject_form.reject_msg"></el-input>
          </el-form-item>
          </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handle_close">取 消</el-button>
          <el-button type="danger" @click="batch_reject" :loading="loading.batch_reject">驳 回</el-button>
        </span>
      </div>
      </el-dialog>
      </div>
  </div>
</template>

<script>
import { 
  user_list,
  get_user_info,
  get_leader_painter,
  approval_pass,
  allot_painter,
  approval_recall,
  operate_self_review,
  get_approval_option,
  paint_task_manage_list,
  paint_task_manage_create_s3,
  paint_task_manage_update,
  paint_task_manage_batch_create,
  paint_task_manage_batch_create_s3,
  batch_verify_api,
  batch_pass_api,
  batch_reject_api,
  batch_delete_api,
  batch_appoint_api,
  batch_appoint_draft_api,
  batch_pass_draft_api,
  batch_update_fields_api,
  allot_painter_draft,
  batch_recall_api,
  get_reject_count,
  get_sync_task,
  production_options,
 } from '../../api/getData'
import {page_constant} from '../../mixins/mixins'
import { handleS3Upload } from '../../utils/s3Upload'
import {
  COLOR_OPTIONS,
  PLAY_TYPE_OPTIONS,
  normalizeColor,
  normalizePlayType,
  formatColor as getColorLabel,
  formatPlayType as getPlayTypeLabel,
  withOriginalTypes,
} from '../../utils/playType'
export default {
  name: 'app_info',
  data() {
    var vaildate_draw_grade = (rule, value, callback)=>{
      if(value===''){
        if(this.form.task_type == '勾线'){ callback( new Error("勾线任务必须选择勾线难度"))}
      } else{
        callback();
      }
    };
    var vaildate_original_require =(rule, value, callback)=>{
      if(value===''){
        if(this.form.task_type == '原创'){ callback( new Error("任务类型为原创, 必须输入原创要求"))}
      } else{
        callback();
      }

    }
    return {
      rules: {
        task_name: [
          { required: true, message: '请输入任务名称', trigger: 'change' },
          { min: 1, max: 64, message: '长度在 1 到 64 个字符', trigger: 'change' }
        ],
        task_type:[
        { required: true, message: '请选择任务类型', trigger: 'change' },
        ],
        color:[
        { required: true, message: '请选择色稿类型', trigger: 'change' },
        ],
        play_type:[
        { required: true, message: '请选择制作类型', trigger: 'change' },
        ],
        paint_manager:[
        { required: true, message: '请指定画师主管', trigger: 'change' },
        ],
        surface_type:[
        { required: true, message: '请选择封面图样式', trigger: 'change' },
        ],
        priority:[
        { required: true, message: '请选择紧急程度', trigger: 'change' },
        ],
        // plan_date:[
        // { required: true, message: '请选择完成日期', trigger: 'change' },
        // ],
        // area_number:[
        // { required: false, message: '请填写区域数'},
        // { type: 'number', message: '区域数必须为数字值'}
        // ],
        // area_number: [
        //   {
        //     validator: (rule, value, callback) => {
        //       if (value === '' || value === undefined || value === null) {
        //         callback();
        //       } else if (typeof value !== 'number' || isNaN(value)) {
        //         callback(new Error('区域数必须为数字值'));
        //       } else {
        //         callback();
        //       }
        //     },
        //     trigger: 'change'
        //   }
        // ],
        plan:[
        { required: true, message: '请选择生产计划', trigger: 'change' },
        ],
        img_cate:[
        { required: true, message: '请选择图片分类', trigger: 'change' },
        ],
        // draw_grade:[
        // { validator: vaildate_draw_grade, trigger: 'change' },
        // ],

      },
      batch_update_fields_rules: {
        paint_manager: [
          { required: true, message: '请指定画师主管', trigger: 'change' },
        ],
        plan: [
          { required: true, message: '请选择生产计划', trigger: 'change' },
        ],
      },
      task_msg: "任务创建 |暂无",
      original_recommemds:[
        "图中英文",
        "去掉画面水印",
        "画面元素可适当简化",
        "左右拓展改为方形构图",
        "上下拓展改为方形构图",
        "裁剪改为方形构图",
        "画面元素参考图1，调整为方型构图"
      ],
      reject_count: "",
      temp_original_require: "",
      msg: "",
      all_select_count: 0,
      selection_rows: [],
      user_info: {"id":"", "username":"", "role":""},
      upload_url: "api/manage/paint_task_manage/upload_image/",
      batch_upload_url: "api/manage/paint_task_manage/batch_upload_image/",
      file_list:[],
      batch_file_list:[],
      file_list_org: [],
      reject_form: {
        id: "",
        reject_msg: ""
      },
      recall_ids: [],
      review_data_form: {
        "id": "",
        "task_type": "",
        "painter": "",
        "paint_leader": "",
        "draw_theme": "",
        "original_grade": "",
        "draw_grade": "",
        "is_appoint":"",
      },
      review_original_type_form: {
        "color": normalizeColor(),
        "play_type": normalizePlayType(),
      },
      batch_update_fields_form: {
        "paint_manager":"",
        "plan": "",
      },
      batch_update_field_type: "",
      tableData: [],
      filter_from: {
        "reject":"",
        "painter":"",
        "task_name":"",
        "approval_code": "",
        "task_type":"",
        "surface_type":"",
        "priority":"",
        "area_number":"",
        "painting":"",
        "painting_create_timestamp_start":"",
        "painting_create_timestamp_end":"",
        "plan":"",
        "img_cate":[],
        "draw_grade":"",
        "draw_theme":"",
        "color":"",
        "play_type":"",
        "original_grade":"",
        "task_status":[],
        "created_by":"",
        "paint_manager":"",
        "subject_id":"",
        "subject_type":"",
        "art_team_id":"",
        "project_team_code":"",
        "offset": 0,
        "limit": 10,
      },
      options: {
        "task_type": [],
        "color": COLOR_OPTIONS,
        "play_type": PLAY_TYPE_OPTIONS,
        "surface_type":[],
        "priority":[],
        "area_number":[],
        "plan":[],
        "all_plan":[],
        "img_cate":[],
        "draw_grade":[],
        "draw_theme":[],
        "original_grade":[],
        "paint_manager": [],
        "boole":[{value: true, label: "是"}, {value: false, label: "否"}],
        "leader_painter": [],
        "all_user":[],
        "subject":[],
        "subject_type":[
          {"value": "normal", "label": "常规"},
          {"value": "special", "label": "特殊"},
        ],
        "art_team":[],
        "project_team":[],
        "task_status": [
            {"value": 1, "label": "运营自审任务"},
            {"value": 2, "label": "运营互审任务"},
            {"value": 3, "label": "画师主管审阅任务"},
            {"value": 4, "label": "组长分配任务 / 编辑任务"},
            {"value": 5, "label": "画师认领"},
            {"value": 6, "label": "组长/主管审核"},
            {"value": 7, "label": "运营审批"},
            {"value": 8, "label": "结束"}
        ],
        "original_create_type":[
          {"value": 1, "label": "按任务数量"},
          {"value": 2, "label": "按参考图片"},
        ],
        "reject":[
          {"label": "是", "value": 1},
          {"label": "否", "value": 0}
        ],
      },
      painter: [],
      leader_painter: [],
      loading: {
        search: false,
        create: false,
        upload_ai: false,
        upload_org: false,
        review: false,
        reject: false,
        update: false,
        delete: false,
        recall: false,
        batch_recall: false,
        batch_create: false,
        batch_upload: false,
        batch_verify: false,
        batch_delete: false,
        batch_reject: false,
        batch_update_fields: false,
        batch_pass: false,
        batch_appoint: false,
        batch_review: false,
        leader_review: false,
        leader_appoint: false,
        sub_review: false,
        sub_batch_pass: false,
        sub_leader_review: false,
        sub_batch_review: false,
        sub_leader_appoint: false,
        sub_batch_appoint: false,
        reject_count: false,
      },
      upload_pending: {
        ai: 0,
        org: 0,
      },
      dialog: {
        create: false,
        review: false,
        update: false,
        reject: false,
        upload: false,
        delete: false,
        recall: false,
        batch_recall: false,
        batch_create: false,
        batch_verify: false,
        batch_delete: false,
        batch_reject: false,
        batch_update_fields: false,
        batch_pass: false,
        batch_appoint: false,
        batch_review: false,
        leader_review:false,
        leader_appoint: false,
      },
      form: {
        "task_name": "",
        "task_type": "勾线",
        "color": normalizeColor(),
        "play_type": normalizePlayType(),
        "surface_type": "灰度",
        "priority": "正常",
        "area_number": "",
        "paint_manager":"hanyawen",
        "plan": "",
        "img_cate": "",
        "ref_image": "",
        "original_require": "",
        "ai_image": "",
        "ai_image_name": "",
        "draw_grade": "",
        "task_number": "",
        "plan_date": "",
        "original_create_type": "",
        "original_images": "",
      },
      update_form: {
        "id": "",
        "task_name": "",
        "task_type": "",
        "color": normalizeColor(),
        "play_type": normalizePlayType(),
        "surface_type": "",
        "priority": "",
        "area_number": "",
        "paint_manager":"",
        "plan": "",
        "img_cate": "",
        "ref_image": "",
        "original_require": "",
        "ai_image": "",
        "ai_image_name": "",
        "draw_grade": "",
        "plan_date": "",
      },
      ...page_constant,
    }
    
  },

  async created() {
    let res_user = await get_user_info()
    this.user_info = res_user.data
    let resp = await get_approval_option()
    let res_users = await user_list({"role": 6, "offset": 0, "limit": 999})
    let leader_painter = await get_leader_painter({"role": this.user_info.role})
    const data = resp.data
    let res_users_1_resp = await user_list({"offset": 0, "limit": 999, "role": 1})
    let res_users_2_resp = await user_list({"offset": 0, "limit": 999, "role": 2})
    this.options.all_user = [...res_users_1_resp.data.results, ...res_users_2_resp.data.results]
    this.options.task_type = data.task_type
    this.options.surface_type = data.surface_type
    this.options.priority = data.priority
    this.options.area_number = Array.isArray(data.area_number) ? data.area_number : []
    this.options.plan = data.plan
    this.options.all_plan = data.all_plan
    this.options.img_cate = data.img_cate
    this.options.draw_grade = Array.isArray(data.draw_grade)
      ? data.draw_grade.some((item) => item && item.text === '极难')
        ? data.draw_grade
        : [...data.draw_grade, { value: '极难', text: '极难' }]
      : [{ value: '极难', text: '极难' }]
    this.options.draw_theme = data.draw_theme
    this.options.original_grade = data.original_grade
    this.options.paint_manager = res_users.data.results
    this.options.leader_painter = leader_painter.data
    try {
      const [subjects, artTeams, projectTeams] = await Promise.all([
        production_options('subject'),
        production_options('art_team'),
        production_options('project_team'),
      ])
      this.options.subject = subjects
      this.options.art_team = artTeams
      this.options.project_team = projectTeams
    } catch (error) {
      this.$message.error('生产维度筛选项加载失败，请刷新页面重试')
    }
    await this.search()
    await this.sync_task_status()
    await this.curr_reject_count()

  },
  computed: {
    // 将全部已选图片分类拼接为 Tooltip 展示文本。
    selectedImgCateText() {
      return this.filter_from.img_cate.join(', ')
    },
    // 计算前两个 Tag 之外仍未展示的图片分类数量。
    imgCateOverflowCount() {
      return Math.max(this.filter_from.img_cate.length - 2, 0)
    },
    // 为 CSS 数量 Tag 提供带引号的文本内容。
    imgCateOverflowCssText() {
      return `"+ ${this.imgCateOverflowCount}"`
    },
    offset() {
      return (this.cur_page - 1)*  this.size
    },
    limit() {
      return this.size
    }
  },
  watch: {
    "form.task_type": {
      handler(){
        if(this.form.task_type == "勾线"){
          this.form.paint_manager = "hanyawen"
          this.form.surface_type = "灰度"
          this.form.priority = "正常"
        }else if(this.form.task_type == "原创"){
          this.form.color = normalizeColor(this.form.color)
          this.form.play_type = normalizePlayType(this.form.play_type)
          this.form.surface_type = "线稿"
          this.form.priority = "正常"
          this.form.paint_manager = "daixingyu"
          this.form.original_require = "画面元素参考图1，调整为方型构图"
          this.form.original_create_type = "按任务数量"
        }
      }
    }
  },
  methods: {
    async handle_upload_request(param) {
  const file = param.file;
  const uploadType = param && param.data && param.data.uploadType ? param.data.uploadType : '';
  if (uploadType === 'ai') {
    this.upload_pending.ai += 1;
    this.loading.upload_ai = true;
  } else if (uploadType === 'org') {
    this.upload_pending.org += 1;
    this.loading.upload_org = true;
  }
  try {
    const url = await handleS3Upload(file);
    const response = { data: { url: url }, status: 200 };
    file.response = response;
    file.url = url;
    param.onSuccess(response);
  } catch (error) {
    console.error("Upload failed:", error);
    param.onError(error);
    this.$message.error('上传失败，请重试');
  } finally {
    if (uploadType === 'ai') {
      this.upload_pending.ai = Math.max(0, this.upload_pending.ai - 1);
      this.loading.upload_ai = this.upload_pending.ai > 0;
    } else if (uploadType === 'org') {
      this.upload_pending.org = Math.max(0, this.upload_pending.org - 1);
      this.loading.upload_org = this.upload_pending.org > 0;
    }
  }
},

// 新增：批次上传方法
async uploadInBatches(files, batchSize = 2, maxRetries = 1) {
  const results = {
    success: [],
    failed: []
  };
  
  console.log(`开始批次上传，共 ${files.length} 个文件，每批 ${batchSize} 个`);
  
  // 第一轮：分批队列上传
  for (let i = 0; i < files.length; i += batchSize) {
    const batch = files.slice(i, i + batchSize);
    const batchIndex = Math.floor(i / batchSize) + 1;
    const totalBatches = Math.ceil(files.length / batchSize);
    
    console.log(`正在上传第 ${batchIndex}/${totalBatches} 批...`);
    
    // 当前批次并行上传（批次内并行，批次间串行）
    const batchPromises = batch.map(file =>
      this.uploadSingleFile(file)
        .then(url => ({
          success: true,
          url: url,
          file: file
        }))
        .catch(error => ({
          success: false,
          error: error,
          file: file
        }))
    );
    
    // 等待当前批次完成
    const batchResults = await Promise.all(batchPromises);
    
    // 记录结果
    batchResults.forEach(result => {
      if (result.success) {
        results.success.push(result);
        console.log(`✓ 上传成功: ${result.file.name}`);
      } else {
        results.failed.push(result);
        console.log(`✗ 上传失败: ${result.file.name}`, result.error);
      }
    });
    
    // 显示进度
    this.$message.info(
      `上传进度: ${i + batch.length}/${files.length} (成功: ${results.success.length}, 失败: ${results.failed.length})`
    );
  }
  
  // 第二轮：重试失败的文件
  if (results.failed.length > 0 && maxRetries > 0) {
    console.log(`\n开始重试 ${results.failed.length} 个失败文件...`);
    
    const retryFiles = results.failed.map(r => r.file);
    const retryResults = {
      success: [],
      failed: []
    };
    
    // 分批重试
    for (let i = 0; i < retryFiles.length; i += batchSize) {
      const batch = retryFiles.slice(i, i + batchSize);
      const batchIndex = Math.floor(i / batchSize) + 1;
      const totalBatches = Math.ceil(retryFiles.length / batchSize);
      
      console.log(`重试第 ${batchIndex}/${totalBatches} 批...`);
      
      const batchPromises = batch.map(file =>
        this.uploadSingleFile(file)
          .then(url => ({
            success: true,
            url: url,
            file: file
          }))
          .catch(error => ({
            success: false,
            error: error,
            file: file
          }))
      );
      
      const batchResults = await Promise.all(batchPromises);
      
      batchResults.forEach(result => {
        if (result.success) {
          retryResults.success.push(result);
          console.log(`✓ 重试成功: ${result.file.name}`);
        } else {
          retryResults.failed.push(result);
          console.log(`✗ 重试失败: ${result.file.name}`);
        }
      });
    }
    
    // 更新最终结果
    results.success.push(...retryResults.success);
    results.failed = retryResults.failed; // 只保留重试后仍然失败的
    
    if (retryResults.success.length > 0) {
      this.$message.success(`重试成功 ${retryResults.success.length} 个文件`);
    }
  }
  
  // 返回最终结果
  console.log(`\n上传完成: 成功 ${results.success.length}, 失败 ${results.failed.length}`);
  return results;
},

// 单个文件上传方法（保持不变）
async uploadSingleFile(file) {
  return new Promise((resolve, reject) => {
    const timeout = setTimeout(() => {
      reject(new Error('上传超时'));
    }, 30000);
    
    handleS3Upload(file)
      .then(url => {
        clearTimeout(timeout);
        resolve(url);
      })
      .catch(error => {
        clearTimeout(timeout);
        reject(error);
      });
  });
},
    async sync_task_status(){
      const ret = await get_sync_task()
      if (ret.code == 200000){
        this.task_msg = ret.message
      }
    },
    async curr_reject_count(){
      this.loading.reject_count = true
      const resp = await get_reject_count()
      console.log("curr_reject_count", resp)
      this.reject_count = resp.data.count
      this.loading.reject_count = false
    },
    querySearch(queryString, cb) {
        var curr_original_require = queryString.split(';')
        const lastQuery = curr_original_require.pop();
        var restaurants = this.original_recommemds;
        var results = lastQuery ? restaurants.filter(item=> item.indexOf(lastQuery)>=0) : restaurants;
        var ret = results.filter(item => !curr_original_require.includes(item))
        cb(ret);
        this.temp_original_require = this.form.original_require

      },
      querySearch_update(queryString, cb) {
        var curr_original_require = queryString.split(';')
        const lastQuery = curr_original_require.pop();
        var restaurants = this.original_recommemds;
        var results = lastQuery ? restaurants.filter(item=> item.indexOf(lastQuery)>=0) : restaurants;
        var ret = results.filter(item => !curr_original_require.includes(item))
        cb(ret);
        this.temp_original_require = this.update_form.original_require

      },
    handleSelect(item){
        let temp_original_require = this.temp_original_require.split(";");
        temp_original_require[temp_original_require.length - 1] = item;
        this.form.original_require = temp_original_require.join(";");
      },
      handleSelect_update(item){
        let temp_original_require = this.temp_original_require.split(";");
        temp_original_require[temp_original_require.length - 1] = item;
        this.update_form.original_require = temp_original_require.join(";");
      },
    async batch_verify(){
      this.loading.batch_verify = true
      const res = await batch_verify_api({"task_ids": this.selection_rows})
      this.loading.batch_verify = false
      if (res.status === 200){
        this.$message.success("批量确认成功")
        this.handle_close()
      }else{
        this.$message.error("批量确认失败");
        this.handle_close()
      }
      this.search()
    },
    async batch_delete(){
      this.loading.batch_delete = true
      const res = await batch_delete_api({"task_ids": this.selection_rows})
      this.loading.batch_delete = false
      if (res.status === 200){
        this.$message.success("批量删除成功")
        this.handle_close()
      }else{
        this.$message.error("批量删除失败");
        this.handle_close()
      }
      this.search()
    },
    async batch_reject(){
      this.loading.batch_reject = true
      const res = await batch_reject_api({"task_ids": this.selection_rows, "msg": this.reject_form.reject_msg})
      this.loading.batch_reject = false
      this.reject_form.reject_msg = ""
      if (res.status === 200){
        this.$message.success("批量驳回成功")
        this.handle_close()
      }else{
        this.$message.error("批量驳回失败");
        this.handle_close()
      }
      this.search()

    },
    async batch_update_fields(){
      let is_valid = true
      await new Promise((resolve) => {
        this.$refs["batch_update_fields_form"].validate((valid) => {
          is_valid = valid
          resolve()
        })
      })
      if (!is_valid){
        this.$message.warning("请检查表单必填项")
        return
      }
      this.loading.batch_update_fields = true
      try {
        const payload = {
          "task_ids": this.selection_rows,
          "plan": this.batch_update_field_type === 'plan' ? this.batch_update_fields_form.plan : null,
          "paint_manager": this.batch_update_field_type === 'paint_manager' ? this.batch_update_fields_form.paint_manager : null
        }
        const res = await batch_update_fields_api(payload)
        if (res.status === 200 || res.code === 200000){
          this.$message.success("批量编辑成功")
          this.handle_close()
          this.search()
        }else{
          this.$message.error("批量编辑失败")
        }
      } catch (err) {
        this.$message.error("批量编辑失败")
      } finally {
        this.loading.batch_update_fields = false
      }
    },
    async batch_pass(){
      // if (this.review_data_form.is_appoint == '是'){
      //   if(this.review_data_form.painter == ""){
      //     this.$message.error("请指定组长")
      //     return
      //   }
      // }else if(this.review_data_form.is_appoint == '否'){

      //   if(this.review_data_form.painter == ""){
      //     this.$message.error("请指定画师")
      //     return
      //   }
      // }else{
      //   this.$message.error("请选择是否由组长分配")
      //   return
      // }
      this.loading.batch_pass = true
      const res = await batch_pass_draft_api({"task_ids": this.selection_rows, ...this.getAssignmentPayload()})
      if (res.status === 200){
        const res2 = await batch_pass_api({"task_ids": this.selection_rows})
        if (res2.status === 200){
          this.$message.success("批量审批成功")
        }else{
          this.$message.error("批量审批失败, 信息: " + (res2.msg || "未知错误"));
        }
      }
      this.handle_close()
      this.set_properties(this.review_data_form, "")
      this.search()
    },
    async sub_batch_pass(){
      this.loading.sub_batch_pass = true;
      const res = await batch_pass_draft_api({"task_ids": this.selection_rows, ...this.getAssignmentPayload()})
      this.loading.sub_batch_pass = false;
      if (res.status === 200){
        this.$message.success("批量审批保存为草稿成功")
        this.handle_close()
      }else{
        this.$message.error("批量审批保存为草稿失败");
        this.handle_close()
      }
      this.set_properties(this.review_data_form, "")
      this.search()
    },
    async batch_recall(){
      this.loading.batch_recall = true
      const resp = await batch_recall_api({"task_ids": this.selection_rows})
      this.loading.batch_recall = false
      if (resp.status === 200){
        this.$message.success("批量撤回成功")
      }else{
        this.$message.error("批量撤回失败");
      }
      this.handle_close()
      this.search()
    },
    async pre_batch_pass(){
      this.dialog.batch_pass = true;
      let paint_manager = ""
      for (let row of this.tableData){
          if(this.selection_rows.includes(row.id)){
            this.review_data_form.task_type = row.task_type
            paint_manager = row.paint_manager
          }
      }
      await this.get_painter(paint_manager)
    },
    async pre_batch_appoint(){
      this.dialog.batch_appoint = true;
      let paint_leader = ""
      for (let row of this.tableData){
          if(this.selection_rows.includes(row.id)){
            this.review_data_form.task_type = row.task_type
            paint_leader = row.paint_leader
          }
      }
      await this.get_painter(paint_leader)
    },
    async pre_batch_review(){
      this.dialog.batch_review = true;
      for (let row of this.tableData){
          if(this.selection_rows.includes(row.id)){
            this.review_data_form.task_type = row.task_type
          }
      }
    },
    pre_batch_update_fields(field_type){
      if (this.all_select_count == 0){
        this.$message.warning("请先选择任务")
        return
      }
      this.batch_update_field_type = field_type
      this.dialog.batch_update_fields = true
    },
    judge_disabled(handle_type){
      let need_status = ""
      if(handle_type=="batch_delete"){
        need_status = 1
        let temp_task_crater_by = []
        for (let row of this.tableData){
          if(this.selection_rows.includes(row.id)){
            temp_task_crater_by.push(row.created_by)
          }
        }
        let is_same = true;
        temp_task_crater_by.forEach(item => {
          is_same = item === this.user_info.username ? is_same : false 
        })
        if (! is_same){ return true}
      }else if(handle_type=="batch_reject"){
        // 批量驳回需要状态全部是运营互审/主管审批/组长审批
        let temp_task_status = []
        for (let row of this.tableData){
          if(this.selection_rows.includes(row.id)){
            temp_task_status.push(row.task_status)
          }
        }
        if(temp_task_status.every(item => item === temp_task_status[0])){
          return ! ((this.user_info.role == 3 && 2 ==temp_task_status[0]) || 
          (this.user_info.role == 6 && 3==temp_task_status[0]) ||
          (this.user_info.role == 2 && 4== temp_task_status[0]))
        }
        return true
      }else if(handle_type=="batch_verify"){
        // 批量确认需要状态全部是运营自审/运营互审/主管审核
        let temp_task_status = []
        let temp_task_crater_by = []

        for (let row of this.tableData){
          if(this.selection_rows.includes(row.id)){
            temp_task_status.push(row.task_status)
            temp_task_crater_by.push(row.created_by)
          }
        }
        if (temp_task_status[0] == 1){
          let is_same = true;
          temp_task_crater_by.forEach(item => {
            is_same = item === this.user_info.username ? is_same : false 
          })
          if (! is_same){ return true}
        }
        if(temp_task_status.every(item => item === temp_task_status[0])){
          return ! (this.user_info.role == 3 && [1,2].includes(temp_task_status[0])) || ( [2,6].includes(this.user_info.role) && 3==temp_task_status[0])
        }
        return true
      }else if (handle_type == "batch_pass"){
        // 批量审批需要是处于主管审批状态而且是同一种任务类型
        let temp_task_status = []
        let temp_task_type = []
        for (let row of this.tableData){
          if(this.selection_rows.includes(row.id)){
            temp_task_type.push(row.task_type)
            temp_task_status.push(row.task_status)
          }
        }        
        if(temp_task_status.every(item => item === temp_task_status[0]) & temp_task_type.every(item => item === temp_task_type[0])){
          return !(this.user_info.role == 6 && 3==temp_task_status[0])
        }
      }else if (handle_type == "batch_appoint"){
        // 批量审批需要是处于组长分配状态而且是同一种任务类型
        let temp_task_status = []
        let temp_task_type = []
        let temp_paint_leader = []
        for (let row of this.tableData){
          if(this.selection_rows.includes(row.id)){
            temp_task_type.push(row.task_type)
            temp_task_status.push(row.task_status)
            temp_paint_leader.push(row.paint_leader)
          }}
        if(temp_task_status.every(item => item === temp_task_status[0]) & temp_task_type.every(item => item === temp_task_type[0]) & 
            temp_paint_leader.every(item => item !== null && item !== "")){
          return ! (this.user_info.role == 2 && 4==temp_task_status[0])}
      }else if(handle_type == "batch_update_fields"){
        const current_username = localStorage.getItem('ms_username')
        for (let row of this.tableData){
          if(this.selection_rows.includes(row.id)){
            if(![0, 1, 2].includes(row.task_status) || row.created_by != current_username){
              return true
            }
          }
        }
        return false
      }else if(handle_type == "batch_review")
      {
        // 组长批量审批
        let temp_task_status = []
        let temp_task_type = []
        let temp_virtual_paint_leader = []
        for (let row of this.tableData){
            if(this.selection_rows.includes(row.id)){
              temp_task_type.push(row.task_type)
              temp_task_status.push(row.task_status)
              temp_virtual_paint_leader.push(row.virtual_paint_leader)
          }
        }       
      if(
        temp_task_status.every(item => item === temp_task_status[0]) & temp_task_type.every(item => item === temp_task_type[0]) & temp_virtual_paint_leader.every(item => item !== null && item !== "")){
          return ! (this.user_info.role == 2 && 4==temp_task_status[0])
        }
      }else{
        return true
      }
      for (let row of this.tableData){
        if(this.selection_rows.includes(row.id) & row.task_status != need_status){
          return true
        }
      }
      return false

    },
    clear_select(){
      this.$refs.multipleTable.clearSelection();
      this.selection_rows=[];
      this.all_select_count=0;
    },
    select(selection, row){
      if (selection.includes(row)){
        this.selection_rows.push(row.id)
        this.all_select_count += 1
      }else{
        this.selection_rows = this.selection_rows.filter(item => item !== row.id);
        if(this.all_select_count > 0 ){
          this.all_select_count -= 1
        }
      }
    },
    select_all(selection){
      let curr_table_ids = []
      for (let row of this.tableData){
        curr_table_ids.push(row.id)
      }
      selection = selection.filter(item => curr_table_ids.includes(item.id))
      let count = 0
      if(selection.length){
        for (let row of selection) {
          if(!this.selection_rows.includes(row.id)){
            count += 1
            this.selection_rows.push(row.id)
          }
        }
      }else{
        for (let row of this.tableData) {
          if(this.selection_rows.includes(row.id)){
            count -= 1
          }
          this.selection_rows = this.selection_rows.filter(item => item !== row.id);
        }
      }
      this.all_select_count += count
    },
    get_disabled(curr_name){
      return this.user_info.username != curr_name
    },
    get_reject_disabled(instance){
      if([2,7].includes(instance.task_status)){
        return this.user_info.role != 3
      }
      else if ([3,6].includes(instance.task_status)){
        return  this.user_info.role != 6
      }
      else if(instance.task_status==4){
        return this.user_info.role != 2
      }
      else if (instance.task_status==5){
        return true
      }
    },
    get_recall_disabled(row){
      if(row.task_status == 2){
        return !(this.user_info.role == 3 && row.created_by == this.user_info.username)
      }
      else if (row.task_status == 3){
        return !(this.user_info.role == 3)
      }
      else if(row.task_status == 4){
        return !(this.user_info.role == 6)
      }
      else if(row.task_status == 5){
        if(this.user_info.role == 2){
          return !(row.paint_leader == this.user_info.username)
        }
        else if(this.user_info.role == 6){
          return !(row.paint_leader == "")
        }
      }
      return true
    },
    async get_painter(leader_name){
      let res_user = await user_list({"leader_name": leader_name, "offset": 0, "limit": 999})
      let leader_user = await user_list({"leader_name": leader_name, "role": 2, "offset": 0, "limit": 999})
      this.leader_painter = leader_user.data.results
      this.painter = res_user.data.results
    },
    handle_success_org(response, file, file_list){
      const list = Array.isArray(file_list) ? file_list : [];
      const normalized = list.map((item) => {
        const responseUrl = item.response && item.response.data && item.response.data.url ? item.response.data.url : item.url;
        return {
          name: item.name,
          url: responseUrl,
          uid: item.uid,
          status: item.status,
          response: item.response,
        };
      });
      this.file_list_org = normalized;
    },
    handle_remove_org(file, file_list){
      if (file && file.uid) {
        this.file_list_org = this.file_list_org.filter(item => item.uid !== file.uid);
        return;
      }
      this.file_list_org = this.file_list_org.filter(item => item.url !== file.url);
    },
    handle_remove(file, file_list){
      this.file_list = []
      this.form.ai_image = ""
      this.form.ai_image_name = ""
    },
    handle_success(response, file, file_list){
      this.file_list = [{"name": file.name, "url": file.response.data.url}]
    },
    handle_success_batch(response, file, file_list){
      const updated_list = file_list.map((item) => {
        if (item.uid === file.uid) {
          const response_url = response && response.data && response.data.url ? response.data.url : item.url;
          return {
            ...item,
            response,
            url: response_url,
          };
        }
        return item;
      });
      this.batch_file_list = updated_list;
      const hasUploading = updated_list.some((f) => f.status === 'uploading' || f.status === 'ready');
      this.loading.batch_upload = hasUploading;
    },
    handle_upload_progress_batch(event, file, file_list){
      const hasUploading = file_list.some((f) => f.status === 'uploading' || f.status === 'ready');
      this.loading.batch_upload = hasUploading;
    },
    handle_upload_change_batch(file, file_list){
      const hasUploading = file_list.some((f) => f.status === 'uploading' || f.status === 'ready');
      this.loading.batch_upload = hasUploading;
    },
    handle_exceed(files, file_list) {
        this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + file_list.length} 个文件`);
    },
    handle_exceed_org(files, file_list) {
        const isOriginalUpdate = this.dialog.update && this.update_form.task_type == '原创';
        const isOriginalCreate = this.dialog.create && this.form.task_type == '原创';
        const limit = (isOriginalUpdate || isOriginalCreate) ? 5 : 1;
        this.$message.warning(`当前限制选择 ${limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + file_list.length} 个文件`);
    },
    handle_exceed_batch(files, file_list) {
        this.$message.warning(`当前限制选择 30 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + file_list.length} 个文件`);
    },
    set_properties(obj, value){
      Object.keys(obj).forEach(key => {
        obj[key] = value
      });
    },
    handle_close(){
      this.set_properties(this.dialog, false)
      this.set_properties(this.loading, false)
      this.set_properties(this.review_data_form, '')
      this.set_properties(this.review_original_type_form, '')
      this.review_original_type_form.color = normalizeColor()
      this.review_original_type_form.play_type = normalizePlayType()
      this.set_properties(this.batch_update_fields_form, '')
      this.batch_update_field_type = ''
      this.file_list = []
      this.batch_file_list = []
      this.file_list_org = []
      this.clear_select()
    },
    formatProductionDimension(row, column, value) {
      if (column.property === 'production_dimensions.subject_type') return { normal: '常规', special: '特殊' }[value] || '-'
      return value === null || value === undefined || value === '' ? '-' : value
    },
    formatPlayType(row, column, cellValue){
      return getPlayTypeLabel(cellValue)
    },
    formatColor(row, column, cellValue){
      return getColorLabel(cellValue)
    },
    getAssignmentPayload(){
      const payload = { ...this.review_data_form }
      if (payload.is_appoint == '是'){
        payload.painter = payload.paint_leader
      }
      delete payload.paint_leader
      return payload
    },
    getReviewPayload(){
      const payload = this.getAssignmentPayload()
      return withOriginalTypes(
        payload,
        { ...payload, ...this.review_original_type_form }
      )
    },
    formatPaintingCreateTimestamp(row, column, cellValue){
      const value = cellValue === undefined && row ? row.painting_create_timestamp : cellValue
      if (value === '' || value === null || value === undefined) {
        return ''
      }
      const timestamp = Number(value)
      if (isNaN(timestamp)) {
        return value
      }
      const date = new Date(timestamp * 1000)
      if (isNaN(date.getTime())) {
        return value
      }
      const pad = value => String(value).padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    },
    formatTimestampForQuery(value){
      if (value === '' || value === null || value === undefined) {
        return ''
      }
      return Math.floor(Number(value) / 1000)
    },
    async search(){
      this.loading.search = true
      const params = Object.assign({}, this.filter_from)
      params.offset = this.offset
      params.limit = this.limit
      if (Array.isArray(params.task_status)) {
        params.task_status = params.task_status.join(',')
      }
      // 将图片分类多选值转换为后端查询接口要求的逗号分隔字符串。
      if (Array.isArray(params.img_cate)) {
        params.img_cate = params.img_cate.join(',')
      }
      params.painting_create_timestamp_start = this.formatTimestampForQuery(params.painting_create_timestamp_start)
      params.painting_create_timestamp_end = this.formatTimestampForQuery(params.painting_create_timestamp_end)
      const res = await paint_task_manage_list(params)
      this.tableData = res.data.results
      this.total_count = res.data.count
      this.loading.search = false
      this.clear_select()
    },
    async create(){
      let is_valid = true
      this.$refs["form"].validate((valid) =>{
        is_valid = valid
        if(! valid){
          return false
        }}
      );
      if (!is_valid){
        return false
      }
      this.loading.create = true
      try {
        if (this.loading.batch_upload) {
          this.$message.warning("文件上传中，请稍后再试");
          return;
        }
        const normalizeUrl = (u) => {
          if (!u) return u;
          return String(u).replace(/^\s*`+|`+\s*$/g, '').trim();
        };
        const normalizeNameToJpg = (n) => {
          if (!n) return '未知文件.jpg';
          var name = String(n).replace(/^\s*`+|`+\s*$/g, '').trim();
          if (name.toLowerCase().endsWith('.jpg')) return name;
          if (name.indexOf('.') > -1) {
            return name.replace(/\.[^.]+$/i, '.jpg');
          }
          return name + '.jpg';
        };

        const payload = withOriginalTypes({
          task_type: this.form.task_type,
          task_name: this.form.task_name,
        }, this.form);
        const optionalFields = ['surface_type', 'priority', 'plan', 'img_cate', 'paint_manager', 'area_number'];
        optionalFields.forEach((key) => {
          if (this.form[key]) payload[key] = this.form[key];
        });
        if (this.form.plan_date && this.form.priority === '紧急') payload.plan_date = this.form.plan_date;

        if (this.form.task_type == "原创"){
          if(this.form.original_require && this.form.original_require.length > 512){
            this.$message.warning("任务类型: 原创, 原创要求字数不超过512")
            return false
          }
          if(this.file_list_org.length==0){
            this.$message.warning("任务类型: 原创, 参考图片必传")
            return false
          }
          const urls = this.file_list_org
            .map((it) => normalizeUrl(it.url))
            .filter((u) => u && String(u).indexOf('blob:') !== 0);
          if (urls.length === 0) {
            this.$message.error('参考图片上传响应异常，请重新上传')
            return false
          }
          if (this.form.original_require) payload.original_require = this.form.original_require;
          payload.ref_images = urls;
          payload.ref_image = urls[0];
        }else{
          if(this.file_list.length==0){
            this.$message.warning("勾线任务必须上传勾线图片")
            return false
          }
          const aiImage = normalizeUrl(this.file_list[0].url);
          if (!aiImage || String(aiImage).indexOf('blob:') === 0) {
            this.$message.error('勾线图片上传响应异常，请重新上传')
            return false
          }
          payload.ai_image = aiImage;
          payload.ai_image_name = normalizeNameToJpg(this.file_list[0].name);
          if (this.form.draw_grade) payload.draw_grade = this.form.draw_grade;
        }

        const resp = await paint_task_manage_create_s3(payload)
        if (!resp || (resp.status !== 200 && resp.code !== 200000)) {
          throw new Error(resp.msg || resp.message || "创建失败")
        }
        this.$message.success("创建成功")
        this.loading.create=false
        this.handle_close()
        this.set_properties(this.form, "")
        this.$refs["form"].resetFields();
        this.form.color = normalizeColor()
        this.form.play_type = normalizePlayType(this.form.play_type)
        this.search()
      } catch (err) {
        this.$message.error(err.message || "创建失败，请稍后重试")
      } finally {
        this.loading.create = false
      }
    },
    async pre_review(data){
      console.log("pre_review", data)
      this.dialog.review = true,
      this.loading.review = false;
      this.review_data_form.id = data.id,
      this.review_data_form.task_type = data.task_type
      this.review_data_form.painter = data.painter || ""
      this.review_data_form.paint_leader = data.paint_leader || ""
      if (data.painter){
        this.review_data_form.is_appoint = "否"
      }else{
        this.review_data_form.is_appoint = "是"
      }
      if (data.task_type == "原创"){
        this.review_data_form.draw_theme = data.draw_theme
        this.review_data_form.original_grade = data.original_grade
        this.review_original_type_form.color = normalizeColor(data.color)
        this.review_original_type_form.play_type = normalizePlayType(data.play_type)
      }else{
        this.review_data_form.draw_grade = data.draw_grade
      }
      await this.get_painter(data.paint_manager)
    },
    async pre_leader_appoint(data){
      this.dialog.leader_appoint = true,
      this.loading.leader_appoint = false;
      this.review_data_form.id = data.id,
      this.review_data_form.painter = data.painter
      this.review_data_form.task_type = data.task_type
      if (data.task_type == "原创"){
        this.review_data_form.draw_theme = data.draw_theme
        this.review_data_form.original_grade = data.original_grade
      }else{
        this.review_data_form.draw_grade = data.draw_grade
      }
      await this.get_painter(data.paint_leader)
    },
    async pre_leader_review(data){
      this.dialog.leader_review = true,
      this.loading.leader_review = false;
      this.loading.sub_leader_review = false;
      this.review_data_form.id = data.id,
      this.review_data_form.painter = data.painter
      this.review_data_form.task_type = data.task_type
      if (data.task_type == "原创"){
        this.review_data_form.draw_theme = data.draw_theme
        this.review_data_form.original_grade = data.original_grade
      }else{
        this.review_data_form.draw_grade = data.draw_grade
      }
    },
    async review(){
      if (this.review_data_form.is_appoint == '是'){
        if(this.review_data_form.paint_leader == ""){
          this.$message.error("请指定组长")
          return
        }
      }else if(this.review_data_form.is_appoint == '否'){
        if(this.review_data_form.painter == ""){
          this.$message.error("请指定画师")
          return
        }
      }else{
        this.$message.error("请选择是否由组长分配")
        return
      }
      this.loading.review = true;
      const resp = await allot_painter(this.review_data_form.id, this.getReviewPayload())
      if(resp.code != 200000){
        this.loading.review = false
        this.$message.error(resp.msg || "操作失败")
        return
      }
      this.set_properties(this.review_data_form, "")
      this.handle_close()
      this.search()
    },
    async sub_review(){
      this.loading.sub_review = true;
      const resp = await allot_painter_draft(this.review_data_form.id, this.getReviewPayload())
      if(resp.code != 200000){
        this.loading.sub_review = false
        this.$message.error(resp.msg || "操作失败")
        return
      }
      this.set_properties(this.review_data_form, "")
      this.handle_close()
      this.search()
    },
    async leader_review(){
      console.log("leader_review", this.review_data_form)
      if(this.review_data_form.painter == ""){
          this.$message.error("请指定画师")
          return
      }
      this.loading.leader_review = true;
      const resp = await allot_painter(this.review_data_form.id, this.review_data_form)
      if(resp.code == 200000){
        this.$message.success("操作成功");
      }else{
        this.$message.error("操作失败, 请检查参数");
      }
      this.set_properties(this.review_data_form, "")
      this.handle_close()
      this.search()
    },
    async sub_leader_review(){
      this.loading.sub_leader_review = true;
      const resp = await allot_painter_draft(this.review_data_form.id, this.review_data_form)
      this.handle_close()
      this.search()
    },
    async batch_appoint(){
      // if(this.review_data_form.painter == ""){
      //     this.$message.error("请指定画师")
      //     return
      // }
      this.loading.batch_appoint = true;
      this.review_data_form["task_ids"] = this.selection_rows
      const resp = await batch_appoint_draft_api(this.review_data_form)
      if(resp.status == 200){
        const res2 = await batch_appoint_api(this.review_data_form)
        if (res2.status === 200){
          this.$message.success("批量分配成功")
        }else{
          this.$message.error("批量分配失败, 信息: " + (res2.msg || "未知错误"));
        }
      }        
      this.$message.success("操作成功");
      this.set_properties(this.review_data_form, "")
      this.handle_close()
      this.search()
      // this.review_data_form["task_ids"] = this.selection_rows
      // const resp = await batch_appoint_api(this.review_data_form)
      // if(resp.status == 200){
      //   this.$message.success("操作成功");
      //   this.set_properties(this.review_data_form, "")
      //   this.handle_close()
      //   this.search()
      // }else{
      //   this.$message.error("操作失败, 请检查参数");
      //   this.loading.batch_appoint = false;
      // }
    },
    async sub_batch_appoint(){
      this.loading.sub_batch_appoint = true;
      this.review_data_form["task_ids"] = this.selection_rows
      const resp = await batch_appoint_draft_api(this.review_data_form)
      this.$message.success("操作成功");
      this.set_properties(this.review_data_form, "")
      this.handle_close()
      this.search()
    },
    async batch_review(){
      this.loading.batch_review = true;
      this.review_data_form["task_ids"] = this.selection_rows
      const resp = await batch_appoint_api(this.review_data_form)
      if(resp.status == 200){
        this.$message.success("操作成功");
        this.set_properties(this.review_data_form, "")
        this.handle_close()
        this.search()
      }else{
        this.$message.error("操作失败, 请检查参数");
      }
      this.loading.batch_review = false;
    },
    async sub_batch_review(){
      this.loading.sub_batch_review = true;
      this.review_data_form["task_ids"] = this.selection_rows
      const resp = await batch_appoint_draft_api(this.review_data_form)
      this.set_properties(this.review_data_form, "")
      this.handle_close()
      this.search()
    },
    pre_reject(data){
      this.dialog.reject = true,
      this.reject_form.id = data.id
    },
    pre_recall(data){
      this.dialog.recall = true
      this.recall_ids.push(data.id)
    },
    async recall(){
      this.loading.recall = true
      const resp = await batch_recall_api({"task_ids": this.recall_ids})
      this.recall_ids = []
      this.handle_close()
      this.search()
    },
    pre_delete(data){
      this.dialog.delete = true,
      this.reject_form.id = data.id
    },
    async reject(){
      const resp = await approval_recall(this.reject_form.id, {"reject_msg": this.reject_form.reject_msg})
      this.set_properties(this.reject_form, "")
      this.handle_close()
      this.search()
    },
    pre_update(data){
      this.dialog.update = true
      Object.keys(this.update_form).forEach(key => {
        this.update_form[key] = data[key]
      });
      this.update_form.color = normalizeColor(this.update_form.color)
      this.update_form.play_type = normalizePlayType(this.update_form.play_type)
      if (this.update_form.task_type == "原创"){
        this.file_list_org = []
        if(this.update_form.ref_image){
          this.file_list_org = this.update_form.ref_image.split(';').map(item => ({'name': '', 'url': item}))
        }
      }else{
        this.file_list = [{"name": this.update_form.ai_image_name, "url": this.update_form.ai_image}]
      }
    },
    async update(){
      this.$refs["update_form"].validate((valid) =>{
        if(! valid){
          return false
        }}
      );
      this.loading.update = true;
      if (this.update_form.task_type == "原创"){
        if(this.update_form.original_require.length > 512){
          this.$message.warning("任务类型: 原创, 原创要求字数不超过512")
          this.loading.update = false
          return false
        }
        if(this.file_list_org.length==0){
          this.update_form.ref_image = ""
          this.$message.warning("任务类型: 原创, 参考图片必传")
          this.loading.update = false
          return false
        } else{
          this.update_form.ref_image = this.file_list_org.map(item=> item.url).join(";")
        }
        this.update_form.ai_image = ""
        this.update_form.ai_image_name = ""
      }else{
        if(this.file_list.length==0){
          this.update_form.ai_image = ""
          this.update_form.ai_image_name = ""
          this.$message.warning("勾线任务必须上传勾线图片")
          this.loading.update = false
          return false
        }else{
          this.update_form.ai_image = this.file_list[0].url
          this.update_form.ai_image_name = this.file_list[0].name
        }
      }
      const payload = withOriginalTypes(this.update_form, this.update_form)
      const resp = await paint_task_manage_update(this.update_form.id, payload)
      this.set_properties(this.update_form, "")
      this.loading.update = false
      this.handle_close()
      this.search()
    },
    async verify_task(task_id){
      const res = await operate_self_review(task_id)
      if ([200, 200000].includes(res.code)){
        this.$message.success("自审成功")
        this.handle_close()
      }else{
        this.$message.error("自审失败");
        this.handle_close()
      }
      this.search()
    },
    async check_approve(task_id, task_status){
      const resp = await approval_pass(task_id, {"task_status": task_status})
      if(resp.code == 200000){
        this.$message.success("操作成功")
      }else{
        this.$message.error("操作失败")
      }
      this.search()
    },
    async recall_task(){

    },
   async batch_create() {
      let is_valid = false;
      await new Promise((resolve) => {
        this.$refs["form"].validate((valid) => {
          is_valid = valid;
          resolve();
        });
      });

      if (!is_valid) {
        this.$message.warning("请检查表单必填项");
        return;
      }

      this.loading.batch_create = true;

      try {
        const normalizeUrl = (u) => {
          if (!u) return u;
          return String(u).replace(/^\s*`+|`+\s*$/g, '').trim();
        };
        const normalizeNameToJpg = (n) => {
          if (!n) return '未知文件.jpg';
          var name = String(n).replace(/^\s*`+|`+\s*$/g, '').trim();
          if (name.toLowerCase().endsWith('.jpg')) return name;
          if (name.indexOf('.') > -1) {
            return name.replace(/\.[^.]+$/i, '.jpg');
          }
          return name + '.jpg';
        };

        let resp;

        const payload = withOriginalTypes({
          task_name: this.form.task_name,
          task_type: this.form.task_type,
          paint_manager: this.form.paint_manager,
          surface_type: this.form.surface_type,
          priority: this.form.priority,
          plan: this.form.plan,
          img_cate: this.form.img_cate,
        }, this.form);

        if (this.form.area_number) payload.area_number = this.form.area_number;
        if (this.form.plan_date && this.form.priority === '紧急') payload.plan_date = this.form.plan_date;

        const batchList = Array.isArray(this.batch_file_list) ? this.batch_file_list : [];

        if (this.form.task_type === "勾线") {
          if (batchList.length === 0) {
            throw new Error("勾线任务必须上传图片");
          }
          const urls = [];
          const names = [];
          for (const item of batchList) {
            if (item.status !== 'success') continue;
            let response_url = '';
            if (item && item.response && item.response.data && item.response.data.url) {
              response_url = item.response.data.url;
            } else if (item && item.url) {
              response_url = item.url;
            }
            response_url = normalizeUrl(response_url);
            if (!response_url || String(response_url).indexOf('blob:') === 0) {
              this.$message.error('文件 ' + (item.name || '') + ' 上传响应异常，请重新上传');
              throw new Error('文件 ' + (item.name || '') + ' 响应格式异常');
            }
            urls.push(response_url);
            names.push(normalizeNameToJpg(item.name || '未知文件'));
          }
          if (urls.length === 0) {
            throw new Error("勾线任务必须上传有效图片");
          }
          payload.draw_grade = this.form.draw_grade;
          payload.ai_images = urls;
          payload.ai_image_names = names;
          resp = await paint_task_manage_batch_create_s3(payload);
        } else if (this.form.task_type === "原创") {
          payload.original_require = this.form.original_require;
          
          if (this.form.original_create_type === "按参考图片") {
            // 从已上传的 batch_file_list 中提取 URL
            const urls = [];
            for (const item of batchList) {
              if (item.status !== 'success') continue;
              let response_url = '';
              if (item && item.response && item.response.data && item.response.data.url) {
                response_url = item.response.data.url;
              } else if (item && item.url) {
                response_url = item.url;
              }
              response_url = normalizeUrl(response_url);
              if (!response_url || String(response_url).indexOf('blob:') === 0) {
                this.$message.error('文件 ' + (item.name || '') + ' 上传响应异常，请重新上传');
                throw new Error('文件 ' + (item.name || '') + ' 响应格式异常');
              }
              urls.push(response_url);
            }
            if (urls.length === 0) {
              throw new Error("按参考图片创建必须上传图片");
            }
            payload.ref_images = urls;
            resp = await paint_task_manage_batch_create_s3(payload);
            
          } else if (this.form.original_create_type === "按任务数量") {
            const num = Number(this.form.task_number);
            if (isNaN(num) || num <= 0) {
              throw new Error("任务数量必须为正整数");
            }
            const oldPayload = withOriginalTypes({
              ...this.form,
              task_number: num
            }, this.form);
            delete oldPayload.ai_image;
            delete oldPayload.ai_image_name;
            delete oldPayload.original_images;
            
            resp = await paint_task_manage_batch_create(oldPayload);
          } else {
            throw new Error("请选择创建方式");
          }
        } else {
           const oldPayload = withOriginalTypes(this.form, this.form);
           resp = await paint_task_manage_batch_create(oldPayload);
        }

        if (!resp || (resp.status !== 200 && resp.code !== 200000)) {
             throw new Error(resp.msg || resp.message || "批量创建失败");
        }

        this.$message.success("批量创建成功");
        this.handle_close();
        this.set_properties(this.form, "");
        this.$refs["form"].resetFields();
        this.form.color = normalizeColor()
        this.form.play_type = normalizePlayType(this.form.play_type)
        this.search();

      } catch (err) {
        console.error("批量创建失败:", err);
        this.$message.error(err.message || "批量创建失败，请稍后重试");

      } finally {
        this.loading.batch_create = false;
      }
    },

  }
}
</script>

<style scoped>
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}

/* 外层筛选表单为 inline，创建弹窗内的字段需要恢复为独占一行。 */
.area-number-form-item,
.create-form > .el-form-item {
  display: block;
  width: 100%;
  clear: both;
}

.uploading-tip {
  margin-top: 6px;
  color: #409eff;
}

/* 图片分类选择器保持单行，并仅展示前两个已选 Tag。 */
.img-cate-select >>> .el-select__tags {
  flex-wrap: nowrap;
  overflow: hidden;
}

.img-cate-select >>> .el-select__tags .el-tag {
  min-width: 0;
}

.img-cate-select >>> .el-select__tags .el-tag:nth-of-type(n + 3) {
  display: none;
}

/* 在前两个 Tag 后补充 Element UI 2 不支持的自定义数量 Tag。 */
.img-cate-select.has-img-cate-overflow >>> .el-select__tags::after {
  content: var(--img-cate-overflow-text);
  order: 1;
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  box-sizing: border-box;
  height: 24px;
  margin: 2px 0 2px 6px;
  padding: 0 8px;
  color: #909399;
  font-size: 12px;
  line-height: 22px;
  white-space: nowrap;
  pointer-events: none;
  background-color: #f4f4f5;
  border: 1px solid #e9e9eb;
  border-radius: 4px;
}

/* 筛选输入框排在数量 Tag 后，并保留可输入空间。 */
.img-cate-select.has-img-cate-overflow >>> .el-select__input {
  order: 2;
  min-width: 12px;
  margin-left: 4px;
}

/* Tooltip 展示全部分类时限制宽度，并允许长分类名称换行。 */
.img-cate-tooltip-content {
  max-width: 400px;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.updata{
margin-left: 10px;
margin-right: 10px;
}

</style>
